// utils/auth.js

export const logout = (onLoggedOut) => {
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  alert("Session expired. Please log in again.");
  if (onLoggedOut) {
    onLoggedOut(); // React updates isAuthenticated
  }
  setTimeout(() => {
    window.location.href = '/login'; // or use navigate()
  }, 1000);
};



export const getUserRole = () => localStorage.getItem("role");

export const isAdminUser = () => {
  const role = getUserRole();
  return role === "admin" || role === "superAdmin";
};



// export const logout = () => {
//   localStorage.removeItem('token');
//     alert("Session expired. Please log in again.");
//     setTimeout(() => {
//   window.location.href = '/login'; // or automatic redirection to login page
//   }, 1000); // 1 second delay
// };


